<div class="col-md-12">
	<input type="hidden" id="determinantUrl" name="determinantUrl" [value]="determinantUrl">
	<input type="hidden" id="triggersUrl" name="triggersUrl" [value]="triggersUrl">
	<input type="hidden" id="formulaUrl" name="formulaUrl" [value]="formulaUrl">
	<input type="hidden" id="tabTabsUrl" name="tabTabsUrl" [value]="tabTabsUrl">
	<input type="hidden" id="tabTranslateUrl" name="tabTranslateUrl" [value]="tabTranslateUrl">
	<input type="hidden" id="dynamicValidationUrl" name="dynamicValidationUrl" [value]="dynamicValidationUrl">
	<input type="hidden" id="blacklistValidationUrl" name="blacklistValidationUrl" [value]="blacklistValidationUrl">
	<formio [form]="form" [submission]="formData.data"
	  [refresh]="refreshForm" (submit)="onSubmit($event)"
	  (change)="onChange($event)"></formio>
</div>
